import './utils/highlight';
import 'react-dropzone-uploader/dist/styles.css';

import React, { useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import App from './App';
import { JWTAuthProvider } from 'contexts/JWTAuth';
import { CartProvider } from 'contexts/CartContext';
import { AdditionalWorkshopCartProvider } from 'contexts/AdditionalWorkshopCartContext';
import ReactGA from 'react-ga4';

ReactGA.initialize('G-PZB7GPLL10');
const root = createRoot(document.getElementById('root'));
const TrackPageView = () => {
    useEffect(() => {
        ReactGA.send({
            hitType: 'pageview',
            page: window.location.pathname + window.location.search,
        });
    }, []);

    return null;
};

root.render(
    <>
        <JWTAuthProvider>
            <CartProvider>
                <AdditionalWorkshopCartProvider>
                    <TrackPageView />
                    <App />
                </AdditionalWorkshopCartProvider>
            </CartProvider>
        </JWTAuthProvider>
    </>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
